import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthProvider as DescopeAuthProvider } from '@descope/react-sdk';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './services/AuthContext';
import AppRoutes from './Routes';
import { useSentryTracking } from './hooks/useSentryTracking';
import { ErrorBoundary } from './components/common/ErrorBoundary';

// Descope project ID from environment variable
const DESCOPE_PROJECT_ID = import.meta.env.VITE_DESCOPE_PROJECT_ID || 'P2xH8zvbz13GIKiVlCfTCZ4a1uOR';

// ScrollToTop component
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App: React.FC = () => {
  // Initialize Sentry tracking
  useSentryTracking();

  return (
    <ErrorBoundary>
      <DescopeAuthProvider projectId={DESCOPE_PROJECT_ID}>
        <AuthProvider>
          <AppRoutes />
          <ScrollToTop />
          <ToastContainer 
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </AuthProvider>
      </DescopeAuthProvider>
    </ErrorBoundary>
  );
};

export default App;
